class Url {
    constructor(url) {
        this.url = this.parse(url);
    }

    setQueryParameter(name, value) {
        this.url.queryParams[name] = value;
    }

    buildUrl() {
        let urlString = `${this.url.protocol}//${this.url.host}${this.url.pathname}`;
        let listOfQueryParams = [];
        console.log(this.url.queryParams);

        for (const name in this.url.queryParams) {
            if (Array.isArray(this.url.queryParams[name])) {
                this.url.queryParams[name].forEach(item => {
                    listOfQueryParams.push(`${name}=${item}`);
                });
            } else {
                listOfQueryParams.push(`${name}=${this.url.queryParams[name]}`);
            }
        }

        if (listOfQueryParams.length !== 0) {
            urlString += "?" + listOfQueryParams.join("&");
        }

        return urlString;
    }

    parse(url) {
        let parser = document.createElement('a');
        let queryParams = {};
        let queries;

        parser.href = url;

        queries = parser.search.replace(/^\?/, '');
        queries = queries.length !== 0 ? queries.split("&") : [];

        for (let i = 0; i < queries.length; i++) {
            let split = queries[i].split('=');

            if (queryParams[split[0]] !== undefined) {
                if (Array.isArray(queryParams[split[0]])) {
                    queryParams[split[0]].push(split[1]);
                } else {
                    queryParams[split[0]] = [queryParams[split[0]], split[1]];
                }
            } else {
                queryParams[split[0]] = split[1];
            }
        }

        return {
            protocol: parser.protocol,
            host: parser.host,
            hostname: parser.hostname,
            port: parser.port,
            pathname: parser.pathname,
            queryParamsRaw: parser.search,
            queryParams: queryParams
        };
    }

    removeQueryParameter(name) {
        delete this.url.queryParams[name];
    }
}

export default Url;
